<template>
	<ListDetailLayout
			:store="assetsStore"
      index-route-name="admin.assets"
			create-permissions="create:assets"
			@on-create="$router.push({ name: 'admin.assets.asset', params: { asset: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, () => refreshAssets(false), params)"
			@on-search="(page) => useOnSearch(page, () => refreshAssets(false), params)"
      :filter="params.filter"
      @on-filter="({ filter }) => useOnFilter(filter, refreshAssets, params)"
	  create-button-admin-page="create-asset-type-btn"
	  search-admin-page="search-asset-input-admin-page"
	>

		<template #list>
			<li v-for="asset in assetsStore.getAssets" :key="asset.id">
				<router-link :to="{ name: 'admin.assets.asset', params: { asset: asset.id } }" v-slot="{isActive}">
					<div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

            <div class="min-w-0 flex flex-row w-full items-start justify-between">
              <div class="flex-1">
                <div class="flex items-start gap-x-3">
                  <p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">
                    {{ asset.name }}</p>

						<!-- Stage badge -->
						<span v-if="asset.stage" class="px-2 py-0.5 text-xs font-medium rounded-md"
								:class="asset.stage === 'complete' ? 'text-green-700 bg-green-100 dark:bg-green-900 dark:text-green-200' : 'text-blue-700 bg-blue-100 dark:bg-blue-900 dark:text-blue-200'">
							{{ asset.stage === 'complete' ? 'Complete' : asset.stage === 'first_stage' ? 'First stage' : asset.stage }}
						</span>

					<!-- Show "Deleted" tag if the asset is soft-deleted -->
					<span
						v-if="asset.is_deleted"
						class="px-2 py-0.5 text-xs font-medium text-red-700 bg-red-100 rounded-md dark:bg-red-900 dark:text-red-200"
					>
						Deleted
					</span>
                </div>
                <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
                  <p class="whitespace-nowrap">
                    {{ asset.company?.name || '-' }}
                  </p>
									<span v-if="asset.vin" class="inline-flex items-center gap-1">
										<span>VIN:</span>
										<span class="font-mono">{{ asset.vin }}</span>
									</span>
                </div>
              </div>
            </div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
				<router-view v-if="$route.params.asset" @on-save="refreshAssets(false)" @on-delete="refreshAssets(false)"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useAssetsStore } from "@/stores/assets.js";
import {useOnFilter, useOnPaginate, useOnSearch} from "@/Composables/Pagination.js";

export default {
	name: "AssetsIndex",
	data() {
		return {
      params: {
        per_page: 50,
        include: ['company'],
        filter: {
          company_ids: [],
          asset_type_ids: [],
        }
      }
		}
	},
	methods: {
    useOnFilter,
		useOnSearch,
		useOnPaginate,
		refreshAssets(silent = true){
			try {
				return this.assetsStore.indexAssets(this.params, silent);
			} catch (e) {
				console.log(e);
			}
		},
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useAssetsStore)
	},
	async mounted() {
		await this.refreshAssets();
		// Listen for global refresh event after asset recovery
		this.$root.$on('refresh-assets-list', () => {
			this.refreshAssets(false);
		});
	},
}
</script>